import ZonaLandingImgLOGO from '@panel/commons/assets/logos/urbania.svg';
import Twitter from '../../assets/icons/twitter.svg';
import Instagram from '../../assets/icons/instagram.svg';
import Facebook from '../../assets/icons/facebook.svg';
import Youtube from '../../assets/icons/youtube.svg';
import AppStore from '../../assets/icons/app_store.svg';
import GooglePlay from '../../assets/icons/google_play.svg';
import bookIcon from '../../assets/icons/bookBlack.svg';

const UBPEDataFooter = {
  footerLinks: [
    {
      title: 'Más Urbania',
      content: [
        {
          controlPanel: 'inmuebles-peru',
          wording: 'Inmuebles en Perú',
          link: 'https://urbania.pe/buscar/propiedades'
        },
        {
          controlPanel: 'publica',
          wording: 'Publicar tu inmueble',
          link: 'https://urbania.pe/publica-tu-aviso'
        },
        {
          controlPanel: 'ayuda',
          wording: 'Ayuda',
          link: 'https://help.urbania.pe/es/'
        },
        {
          controlPanel: 'mapa-sitio',
          wording: 'Mapa del sitio',
          link: 'https://urbania.pe/mapa-de-sitio/'
        },
        {
          controlPanel: 'publicidad',
          wording: 'Publicidad',
          link: 'http://www.naventmedia.com/'
        },
        {
          controlPanel: 'noticias',
          wording: 'Blog',
          link: 'https://urbania.pe/blog'
        },
        {
          controlPanel: 'indice-m2',
          wording: 'Índice m²',
          link: 'https://urbania.pe/blog/urbania-index-lima/'
        },
        {
          controlPanel: 'valuador',
          wording: 'Tasador',
          link: 'https://urbania.pe/valuador/#!/'
        }
      ]
    },
    {
      title: 'Anunciantes',
      content: [
        {
          controlPanel: 'inmobiliarias',
          wording: 'Inmobiliarias',
          link: 'https://urbania.pe/inmobiliarias.bum'
        },
        {
          controlPanel: 'corredores',
          wording: 'Corredores',
          link: 'https://urbania.pe/corredores.bum'
        },
        {
          controlPanel: 'constructoras',
          wording: 'Constructoras',
          link: 'https://urbania.pe/constructoras.bum'
        }
      ],
      content2: {
        title: 'Fonoventas',
        content: [
          {
            controlPanel: 'Fonoventas',
            wording: '715-8411 Opción 1',
            link: 'tel:715-8411'
          }
        ]
      }
    },
    {
      title: 'Países',
      content: [
        {
          controlPanel: 'argentina',
          wording: 'Argentina',
          options: [
            {
              wording: 'Zonaprop',
              link: 'https://www.zonaprop.com.ar/'
            }
          ]
        },
        {
          controlPanel: 'brasil',
          wording: 'Brasil',
          options: [
            {
              wording: 'Imovelweb',
              link: 'https://www.imovelweb.com.br'
            },
            {
              wording: 'Wimoveis',
              link: 'https://www.wimoveis.com.br'
            },
            {
              wording: 'CasaMineira',
              link: 'https://www.casamineira.com.br'
            },
            {
              wording: 'QuintoAndar',
              link: 'https://www.quintoandar.com.br/ '
            }
          ]
        },
        {
          controlPanel: 'ecuador',
          wording: 'Ecuador',
          options: [
            {
              wording: 'Plusvalia',
              link: 'https://www.plusvalia.com'
            }
          ]
        },
        {
          controlPanel: 'mexico',
          wording: 'México',
          options: [
            {
              wording: 'Inmuebles24',
              link: 'https://www.inmuebles24.com/'
            },
            {
              wording: 'Vivanuncios',
              link: 'https://www.vivanuncios.com.mx'
            }
          ]
        },
        {
          controlPanel: 'panama',
          wording: 'Panamá',
          options: [
            {
              wording: 'Compreoalquile',
              link: 'https://www.compreoalquile.com'
            }
          ]
        },
        {
          controlPanel: 'peru',
          wording: 'Perú',
          options: [
            {
              wording: 'Adondevivir',
              link: 'https://www.adondevivir.com'
            }
          ]
        }
      ]
    },
    {
      title: 'Fonoventas',
      content: [
        {
          controlPanel: 'Fonoventas',
          wording: '715-8411 Opción 1',
          link: 'tel:715-8411'
        }
      ]
    }
  ],
  socialMedia: {
    title: 'Seguinos en',
    content: [
      {
        wording: 'Facebook',
        link: 'https://www.facebook.com/urbaniaperu',
        src: Facebook
      },
      {
        wording: 'Instagram',
        link: 'https://instagram.com/urbaniaperu',
        src: Instagram
      },
      {
        wording: 'Youtube',
        link: 'https://youtube.com/user/urbaniape',
        src: Youtube
      },
      {
        wording: 'Twitter',
        link: 'https://twitter.com/urbaniape',
        src: Twitter
      }
    ]
  },
  appsLinks: {
    title: 'Apps',
    content: [
      {
        wording: 'AppStore',
        link: 'https://apps.apple.com/pe/app/urbania/id643980058',
        src: AppStore
      },
      {
        wording: 'GooglePlay',
        link: 'https://play.google.com/store/apps/details?id=com.urbania.urbaniaandroidapp',
        src: GooglePlay
      }
    ]
  },
  legalLinks: {
    termsAndConditions: {
      url: 'https://help.urbania.pe/es/articles/3606316-terminos-y-condiciones-de-uso',
      wording: 'Términos y Condiciones de Uso',
      tag: null
    },
    termsAndConditionsHiring: {
      url: 'https://help.urbania.pe/es/articles/3608394-terminos-y-condiciones-generales-de-contratacion',
      wording: 'Términos y Condiciones de Contratación',
      tag: null
    },
    privacyPolicy: {
      url: 'https://help.urbania.pe/es/articles/3606317-politica-de-privacidad',
      wording: 'Política de privacidad',
      tag: null
    },
    bookComplaints: {
      url: 'https://librodereclamaciones.com.pe/ingresar.php',
      wording: 'Libro de reclamaciones',
      tag: null,
      img: bookIcon
    }
  },
  siteName: {
    name: 'urbania.pe'
  },
  logo: {
    src: ZonaLandingImgLOGO
  }
};

export { UBPEDataFooter };
